import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { FormulasOptions } from "@shared/enums/formulas-options";
import { ForOptTarif } from "@shared/enums/foropttarif.enum";
import { PolicyFields } from "@shared/enums/policy-fields.enum";
import {
  getCalendarClass,
  getDropdownClass,
  getInputClass,
  getIsEditable,
  getIsVisible,
  getIsOptionEditable,
} from "@shared/helpers/contract-edition.helper";
import { PolicyDetail, RiskItemInformationsVm } from "@shared/models/policy-details";
import { PolicyFieldsVM } from "@shared/models/policy-field-vm.model";
import { Guid } from "guid-typescript";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { DropdownModule } from "primeng/dropdown";

@Component({
  selector: "app-contract-edition-children-mrh",
  standalone: true,
  imports: [TranslateModule, FormsModule, DropdownModule, CommonModule, ButtonModule, CalendarModule],

  templateUrl: "./contract-edition-children-mrh.component.html",
})
export class ContractEditionChildrenMrhComponent {
  @Input() policyFieldsVM!: PolicyFieldsVM;
  @Input() policyDetailsCopy!: PolicyDetail;
  @Input() childrenInformations: RiskItemInformationsVm[] = [];
  @Input() childrenInformationsInitialValue: RiskItemInformationsVm[] = [];
  @Input() childFirstNameHasChanged: boolean[] = [];
  @Input() childLastNameHasChanged: boolean[] = [];
  @Input() childBirthDateHasChanged: boolean[] = [];
  @Input() isSchoolInsuranceSelected!: boolean | undefined;
  @Input() hasEndorsementWait4Sign!: boolean;
  @Output() emitFormValidity = new EventEmitter<number>();
  @Output() emitChildrenInformations = new EventEmitter<RiskItemInformationsVm[]>();
  options = FormulasOptions;
  ForOptTarif = ForOptTarif;
  PolicyFields = PolicyFields;
  minTerminationDate: Date | null = null;
  maxTerminationDate: Date | null = null;
  preventOptionSubscription: boolean = false;

  getIsVisible = getIsVisible;
  getIsEditable = getIsEditable;
  getInputClass = getInputClass;
  getDropdownClass = getDropdownClass;
  getCalendarClass = getCalendarClass;
  getIsOptionEditable = getIsOptionEditable;

  ngOnInit(): void {
    this.setInitialValues();
  }

  setInitialValues() {
    this.preventOptionSubscription = this.policyDetailsCopy.formulasAndOptionsInformations.preventOptionSubscription;
  }


  addChild() {
    const childRiskItems = this.policyDetailsCopy.formulasAndOptionsInformations.options.find(
      x => x.type === this.options.RCS
    )!.riskItemValues;

    // We limit to 6 children maximum
    if(childRiskItems.length > 5){
      return;
    }


    let childRIskItem;
    let nomEnfant;
    let prenomEnfant;
    let dateEnfant;

    if (childRiskItems && childRiskItems.length > 0) {
      childRIskItem = childRiskItems[0];
      nomEnfant = childRIskItem.values.find(x => x.code === this.ForOptTarif.NOM_ENFANT)!;
      prenomEnfant = childRIskItem.values.find(x => x.code === this.ForOptTarif.PRENOM_ENFANT);
      dateEnfant = childRIskItem.values.find(x => x.code === this.ForOptTarif.DATE_ENFANT);
    } else {
      nomEnfant = { name: "Nom enfant", fieldId: 30 };
      prenomEnfant = { name: "Prénom enfant", fieldId: 29 };
      dateEnfant = { name: "Date de naissance enfant", fieldId: 31 };
    }
    const child: RiskItemInformationsVm = {
      id: Guid.create().toString(),

      riskItemName: "Enfant",
      values: [
        {
          id: Guid.create().toString(),
          name: prenomEnfant?.name,
          value: "",
          code: this.ForOptTarif.PRENOM_ENFANT,
          fieldId: prenomEnfant?.fieldId,
        },
        {
          id: Guid.create().toString(),
          name: nomEnfant?.name,
          value: "",
          code: this.ForOptTarif.NOM_ENFANT,
          fieldId: nomEnfant?.fieldId,
        },
        {
          id: Guid.create().toString(),
          name: dateEnfant?.name,
          value: "",
          code: this.ForOptTarif.DATE_ENFANT,
          fieldId: dateEnfant?.fieldId,
        },
      ],
    };

    this.childrenInformations = [...this.childrenInformations, child];
    this.childrenInformationsInitialValue = [...this.childrenInformationsInitialValue, child];
    this.childBirthDateHasChanged.push(false);
    this.childFirstNameHasChanged.push(false);
    this.childLastNameHasChanged.push(false);
    this.emitChildrenInformations.emit(this.childrenInformations);
    this.emitFormValidity.emit(0);
  }

  onChildRemove(index: number) {
    this.childrenInformations = [
      ...this.childrenInformations.slice(0, index),
      ...this.childrenInformations.slice(index + 1),
    ];
    this.childrenInformationsInitialValue = [
      ...this.childrenInformations.slice(0, index),
      ...this.childrenInformations.slice(index + 1),
    ];
    this.childBirthDateHasChanged = [
      ...this.childBirthDateHasChanged.slice(0, index),
      ...this.childBirthDateHasChanged.slice(index + 1),
    ];
    this.childFirstNameHasChanged = [
      ...this.childFirstNameHasChanged.slice(0, index),
      ...this.childFirstNameHasChanged.slice(index + 1),
    ];
    this.childLastNameHasChanged = [
      ...this.childLastNameHasChanged.slice(0, index),
      ...this.childLastNameHasChanged.slice(index + 1),
    ];
    this.emitChildrenInformations.emit(this.childrenInformations);
    this.emitFormValidity.emit(0);
  }

  onChildFirstNameChange(index: number) {
    this.childFirstNameHasChanged[index] =
      this.childrenInformations[index].values.find(x => x.code === this.ForOptTarif.PRENOM_ENFANT)!.value !==
      this.childrenInformationsInitialValue[index].values.find(x => x.code === this.ForOptTarif.PRENOM_ENFANT)!.value;
    this.emitFormValidity.emit(0);
  }

  onChildLastNameChange(index: number) {
    this.childLastNameHasChanged[index] =
      this.childrenInformations[index].values.find(x => x.code === this.ForOptTarif.NOM_ENFANT)!.value !==
      this.childrenInformationsInitialValue[index].values.find(x => x.code === this.ForOptTarif.NOM_ENFANT)!.value;
    this.emitFormValidity.emit(0);
  }

  onChildBirthDateChange(index: number) {
    this.childBirthDateHasChanged[index] =
      this.childrenInformations[index].values.find(x => x.code === this.ForOptTarif.DATE_ENFANT)!.value !==
      this.childrenInformationsInitialValue[index].values.find(x => x.code === this.ForOptTarif.DATE_ENFANT)!.value;
    this.emitFormValidity.emit(0);
  }
}
